module.exports = __webpack_public_path__ + "img/ico-cases.93cb72d1.svg";